import MessageSheet from '@/components/MessageSheet.tsx';
import { authService } from '@/service/AuthService';
import { useSettingsStore } from '@/store/SettingsStore';
import { Language, SUPPORTED_LANGUAGES } from 'intermind';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useSearchParams } from 'react-router-dom';

const AuthGuard = () => {
  const [searchParams] = useSearchParams();
  const { setLanguage } = useSettingsStore();
  const { t } = useTranslation();
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      try {
        const locale = searchParams.get('locale') || undefined;
        if (locale && SUPPORTED_LANGUAGES.includes(locale as Language)) {
          setLanguage(locale as Language);
        }

        const authorized = await authService.isAuthorized();
        if (authorized) {
          setIsAuthorized(true);
        } else {
          const currentUrl = window.location.href;
          authService.login(currentUrl, locale);
        }
      } catch (error) {
        console.error('Authorization check failed:', error);
        // If authorization check fails, redirect to login
        const currentUrl = window.location.href;
        const locale = searchParams.get('locale') || undefined;
        authService.login(currentUrl, locale);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [searchParams, setLanguage]);

  return isAuthorized && !isLoading ? <Outlet /> : <MessageSheet message={t('loading.text')} />;
};

export default AuthGuard;
